import { FC } from 'react';

import {
    Accordion,
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableRow,
    Text,
    useBreakpoint,
    VSpacing,
    VSpacingContainer,
} from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { ModerationReason } from 'store/models/moderation';

const TrlKeys = {
    title: 'admin.moderationReasonsList.table.title',
    deafultComment: 'admin.moderationReasonsList.table.defaultComment',
    description: 'admin.moderationReasonsList.table.description',
    empty: 'admin.moderationReasonsList.empty',
};

export const ReasonsList: FC<{ reasons: ModerationReason[] }> = ({ reasons }) => {
    const trls = useTrls();

    const { isMobile } = useBreakpoint();

    if (reasons.length === 0) {
        return (
            <Text typography="label-3-regular" data-qa="moderation-reasons-empty">
                {trls(TrlKeys.empty)}
            </Text>
        );
    }

    return (
        <>
            {isMobile ? (
                <VSpacingContainer default={16}>
                    {reasons.map(({ id, title, defaultComment, description }) => (
                        <Accordion
                            key={id}
                            title={
                                <Text typography="title-5-semibold" data-qa={`moderation-reason-title-${id}`}>
                                    {title}
                                </Text>
                            }
                            stretched
                        >
                            <Text typography="label-3-regular" data-qa={`moderation-reason-comment-${id}`}>
                                {defaultComment}
                            </Text>
                            <VSpacing default={10} />
                            <Text
                                typography="label-4-regular"
                                style="secondary"
                                data-qa={`moderation-reason-description-${id}`}
                            >
                                {description}
                            </Text>
                        </Accordion>
                    ))}
                </VSpacingContainer>
            ) : (
                <Table divider styleHighlighted="secondary">
                    <TableHeader>
                        <TableRow>
                            <TableCell m={3}>
                                <Text typography="title-5-semibold">{trls(TrlKeys.title)}</Text>
                            </TableCell>
                            <TableCell m={5}>
                                <Text typography="title-5-semibold">{trls(TrlKeys.deafultComment)}</Text>
                            </TableCell>
                            <TableCell m={4}>
                                <Text typography="title-5-semibold">{trls(TrlKeys.description)}</Text>
                            </TableCell>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {reasons.map(({ id, title, defaultComment, description }) => (
                            <TableRow key={id} data-qa={`moderation-reason-${id}`}>
                                <TableCell m={3}>
                                    <Text typography="label-3-regular" data-qa={`moderation-reason-title-${id}`}>
                                        {title}
                                    </Text>
                                </TableCell>
                                <TableCell m={5}>
                                    <Text typography="label-3-regular" data-qa={`moderation-reason-comment-${id}`}>
                                        {defaultComment}
                                    </Text>
                                </TableCell>
                                <TableCell m={4}>
                                    <Text typography="label-3-regular" data-qa={`moderation-reason-description-${id}`}>
                                        {description}
                                    </Text>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            )}
        </>
    );
};
